const ETHERSCAN_PREFIXES = {
  1: "",
  11155111: "sepolia.",
};

type EtherscanLinkType = "address" | "transaction";

export const getEtherscanLink = (
  networkId: number,
  data: string,
  type: EtherscanLinkType = "transaction"
) => {
  const prefix = `https://${
    ETHERSCAN_PREFIXES[networkId] || ETHERSCAN_PREFIXES[1]
  }etherscan.io`;

  if (type === "address") {
    return `${prefix}/address/${data}`;
  }
  return `${prefix}/tx/${data}`;
};
